import { render, staticRenderFns } from "./_partnerBetTypeList.vue?vue&type=template&id=07b27a58&scoped=true&lang=pug&"
import script from "./_partnerBetTypeList.vue?vue&type=script&lang=js&"
export * from "./_partnerBetTypeList.vue?vue&type=script&lang=js&"
import style0 from "./_partnerBetTypeList.vue?vue&type=style&index=0&id=07b27a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b27a58",
  null
  
)

export default component.exports